import { useTimer } from '@siberiacancode/reactuse'
import React, { useState, useEffect } from "react";
import { isMobile } from 'react-device-detect';
import { Input, Typography, Button, ConfigProvider, Flex } from 'antd';
import { sendSMSCode, verifySMSCode } from "../components/api";
import { getButtonTheme } from '../styles/SMSVerification';

export const SMSVerification = ({
    pageTitleTheme,
    pageDescriptionTheme,
    phoneNumberRepresentation,
    formatedPhoneNumber,
    onRightInputedCode,
    buttonClassName
}) => {
    const { Text, Title } = Typography;

    const [buttonDisabled, setButtonDisabled] = useState(false);

    // из-за особенностей работы таймера нужно устанавливать значение + 1. Т.е. не 60, а 61
    const timerStart = 61;

    const getButtonTextBySeconds = (seconds) => seconds === 0 ? `Отправить код повторно` : `Запросить код повторно через ${seconds - 1} сек`;
    const [buttonText, setButtonText] = useState(getButtonTextBySeconds(timerStart));
    const setButtonTextBySeconds = (seconds) => setButtonText(getButtonTextBySeconds(seconds));

    const [timerIsExprire, setTimerIsExprire] = useState(false);
    const { restart } = useTimer(
        timerStart,
        {
            onExpire: () => {
                setTimerIsExprire(true);
                setButtonTextBySeconds(0);
                setButtonDisabled(false);
            },
            onStart: () => {
                setTimerIsExprire(false);
                setButtonTextBySeconds(timerStart);
                setButtonDisabled(true);
            },
            onTick: (seconds) => setButtonTextBySeconds(seconds)
        }
    );

    useEffect(() => {
        if (timerIsExprire)
            setButtonTextBySeconds(0)
    }, [timerIsExprire]);

    const handleSendNewCodeButtonClick = (eventArgs) => {
        if (timerIsExprire) {
            sendSMSCode({ phone: formatedPhoneNumber }).then(
                () => restart(timerStart, true),
                (error) => { }
            );
        }
    }

    const handleCodeInputFinish = (value) => {
        setButtonDisabled(true);

        verifySMSCode(
            {
                phone: formatedPhoneNumber,
                code: value
            }
        ).then(
            () => {
                onRightInputedCode(value);
                
                setButtonDisabled(false);
            },
            (error) => {
                setButtonDisabled(false);
             }
        );
    }

    const PageTitle = () => (
        <ConfigProvider theme={pageTitleTheme}>
            <Title>Код из СМС</Title>
        </ConfigProvider>
    );

    const PageDescription = ({ text }) => (
        <ConfigProvider theme={pageDescriptionTheme}>
            <Text>Введите код из СМС, отправленный на номер {isMobile ? '' : <br />} {phoneNumberRepresentation}</Text>
        </ConfigProvider>
    );

    return (
        <Flex vertical gap="medium" align="center">
            <PageTitle />
            <PageDescription />


            <Flex vertical align="stretch">
                <Input.OTP onChange={handleCodeInputFinish} size="large" length={4} />
            </Flex>

            <Flex vertical align="stretch">
                <ConfigProvider theme={getButtonTheme()}>
                    <Button className={buttonClassName} size="large" onClick={handleSendNewCodeButtonClick} disabled={buttonDisabled}>{buttonText}</Button>
                </ConfigProvider>
            </Flex>
        </Flex>
    );
}